import React, { useEffect, useRef } from 'react';
import ReactDOM from 'react-dom';
import { openQuoteChat, setChatWidgetVisible } from '../../../../utils/site';
import { trackEvent } from '../../../../utils/firebase';
import OrbitStarVariantPicker from './OrbitStarVariantPicker';

const OrbitStarVariantsModal = ({ section, isOpen, onClose, source, initialModelId }) => {
    const closeRef = useRef(null);

    useEffect(() => {
        if (!isOpen) return undefined;
        trackEvent('variants_open', { source });
        const previousFocus = document.activeElement;
        const previousOverflow = document.body.style.overflow;
        document.body.style.overflow = 'hidden';
        // The chat bubble sits over the sheet's sticky Buy Now bar on phones.
        setChatWidgetVisible(false);
        closeRef.current?.focus();

        const handleKey = (event) => {
            if (event.key === 'Escape') onClose();
        };
        document.addEventListener('keydown', handleKey);

        return () => {
            document.removeEventListener('keydown', handleKey);
            document.body.style.overflow = previousOverflow;
            setChatWidgetVisible(true);
            previousFocus?.focus?.();
        };
    }, [isOpen, onClose, source]);

    if (!isOpen) return null;

    const handleBuy = () => {
        onClose();
        setChatWidgetVisible(true);
        openQuoteChat();
    };

    return ReactDOM.createPortal(
        <div className="orbit-star-variants-modal" onClick={onClose}>
            <div
                className="orbit-star-variants-modal-dialog"
                role="dialog"
                aria-modal="true"
                aria-labelledby="orbit-star-variants-modal-title"
                onClick={(event) => event.stopPropagation()}
            >
                <div className="orbit-star-variants-modal-header">
                    <div>
                        <span className="orbit-star-variants-modal-eyebrow">{section.subtitle}</span>
                        <h2 id="orbit-star-variants-modal-title" className="orbit-star-variants-modal-title">
                            {section.modalTitle}
                        </h2>
                    </div>
                    <button
                        ref={closeRef}
                        type="button"
                        className="orbit-star-variants-modal-close"
                        aria-label={section.closeLabel}
                        onClick={onClose}
                    >
                        <span aria-hidden="true">×</span>
                    </button>
                </div>
                <OrbitStarVariantPicker
                    section={section}
                    onBuy={handleBuy}
                    className="is-modal"
                    initialModelId={initialModelId}
                    trackingLocation="modal"
                />
            </div>
        </div>,
        document.body
    );
};

export default OrbitStarVariantsModal;
